
(function () {
  function getQuantityForForm(form) {
    if (!form) return 1;
    var qty = form.querySelector('[name="quantity"]');
    if (!qty && form.id) {
      qty = document.querySelector('[name="quantity"][form="' + form.id + '"]');
    }
    var value = qty ? parseInt(qty.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function initBuyNowButtons() {
    document.querySelectorAll('[data-dfm-buy-now]').forEach(function (button) {
      if (button.dataset.dfmBound === 'true') return;
      button.dataset.dfmBound = 'true';

      button.addEventListener('click', function () {
        var productForm = button.closest('product-form');
        var form = productForm ? productForm.querySelector('form') : button.closest('form');
        if (!form) return;

        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value || button.disabled) return;

        button.disabled = true;
        button.classList.add('loading');

        var formData = new FormData();
        formData.append('id', idInput.value);
        formData.append('quantity', getQuantityForForm(form));

        fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (error) {
            console.error(error);
            button.disabled = false;
            button.classList.remove('loading');
          });
      });
    });

    document.querySelectorAll('[data-dfm-make-offer]').forEach(function (button) {
      if (button.dataset.dfmBound === 'true') return;
      button.dataset.dfmBound = 'true';

      button.addEventListener('click', function () {
        var card = button.closest('.dfm-price-offer-card');
        var sourceInput = card ? card.querySelector('[data-dfm-offer-source]') : null;
        var modalId = button.getAttribute('data-dfm-modal-target');
        var modal = modalId ? document.getElementById(modalId) : null;

        if (!modal) {
          if (sourceInput) sourceInput.focus();
          return;
        }

        var modalPriceInput = modal.querySelector('[data-dfm-offer-modal-price]');
        if (sourceInput && modalPriceInput && sourceInput.value.trim() !== '') {
          modalPriceInput.value = sourceInput.value.trim().replace(/[^0-9.]/g, '');
        }

        modal.hidden = false;
        document.documentElement.classList.add('dfm-offer-modal-open');
        document.body.style.overflow = 'hidden';

        var firstInput = modal.querySelector('input:not([type="hidden"])');
        setTimeout(function () {
          if (firstInput) firstInput.focus();
        }, 80);
      });
    });

    document.querySelectorAll('[data-dfm-offer-modal]').forEach(function (modal) {
      if (modal.dataset.dfmModalBound === 'true') return;
      modal.dataset.dfmModalBound = 'true';

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('dfm-offer-modal-open');
        document.body.style.overflow = '';
      }

      modal.querySelectorAll('[data-dfm-offer-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', closeModal);
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initBuyNowButtons);
  document.addEventListener('shopify:section:load', initBuyNowButtons);
})();

(function () {
  function dfmHashString(value) {
    value = String(value || 'dfm-product');
    var hash = 0;
    for (var i = 0; i < value.length; i += 1) {
      hash = ((hash << 5) - hash) + value.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function dfmRandomInRange(seed, min, max, salt) {
    min = parseInt(min, 10);
    max = parseInt(max, 10);
    if (!Number.isFinite(min)) min = 1;
    if (!Number.isFinite(max)) max = min;
    if (max < min) {
      var temp = max;
      max = min;
      min = temp;
    }
    var range = (max - min) + 1;
    return min + ((seed + salt) % range);
  }

  function initDfmRandomUrgency() {
    document.querySelectorAll('[data-dfm-random-urgency]').forEach(function (bar) {
      var productId = bar.getAttribute('data-product-id') || window.location.pathname;
      var seed = dfmHashString(productId + '|' + window.location.pathname);

      var viewersEl = bar.querySelector('[data-dfm-viewers-text]');
      var stockEl = bar.querySelector('[data-dfm-stock-text]');

      if (viewersEl && bar.getAttribute('data-random-viewers') === 'true') {
        var viewers = dfmRandomInRange(seed, bar.getAttribute('data-viewers-min'), bar.getAttribute('data-viewers-max'), 17);
        var viewersPrefix = bar.getAttribute('data-viewers-prefix') || '';
        var viewersSuffix = bar.getAttribute('data-viewers-suffix') || 'people are viewing this right now';
        viewersEl.textContent = (viewersPrefix ? viewersPrefix + ' ' : '') + viewers + ' ' + viewersSuffix;
      }

      if (stockEl && bar.getAttribute('data-random-stock') === 'true') {
        var stock = dfmRandomInRange(seed, bar.getAttribute('data-stock-min'), bar.getAttribute('data-stock-max'), 43);
        var stockPrefix = bar.getAttribute('data-stock-prefix') || 'Only';
        var stockSuffix = bar.getAttribute('data-stock-suffix') || 'left in stock';
        stockEl.textContent = stockPrefix + ' ' + stock + ' ' + stockSuffix;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initDfmRandomUrgency);
  document.addEventListener('shopify:section:load', initDfmRandomUrgency);
})();
